import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7325db6a")

_pushScopeId("data-v-7325db6a")
const _hoisted_1 = {
  class: "tariff-detail",
  "data-testid": "booking-v4-tarif-detail-panel"
}
const _hoisted_2 = { class: "tariff-detail__header" }
const _hoisted_3 = { class: "flex flex-col gap-2 py-3 px-4" }
const _hoisted_4 = { class: "tariff-detail__section" }
const _hoisted_5 = { class: "tariff-detail__label" }
const _hoisted_6 = {
  key: 0,
  class: "tariff-detail__note"
}
const _hoisted_7 = { class: "tariff-detail__section" }
const _hoisted_8 = { class: "tariff-detail__section" }
const _hoisted_9 = { class: "tariff-detail__row black-text" }
const _hoisted_10 = {
  class: "tariff-detail__badge",
  "data-testid": "booking-v4-tarif-detail-protection"
}
const _hoisted_11 = { class: "tariff-detail__row black-text" }
const _hoisted_12 = {
  key: 0,
  class: "tariff-detail__section"
}
const _hoisted_13 = { class: "tariff-detail__row" }
const _hoisted_14 = { class: "tariff-detail__row" }
const _hoisted_15 = { class: "tariff-detail__row" }
const _hoisted_16 = {
  key: 1,
  class: "tariff-detail__section"
}
const _hoisted_17 = { class: "tariff-detail__discount-label" }
const _hoisted_18 = {
  key: 0,
  class: "tariff-detail__promo-chip"
}
const _hoisted_19 = { class: "is-discount" }
const _hoisted_20 = {
  key: 2,
  class: "tariff-detail__section"
}
const _hoisted_21 = { class: "tariff-detail__row" }
const _hoisted_22 = { class: "is-tax" }
const _hoisted_23 = { class: "is-tax" }
const _hoisted_24 = { class: "tariff-detail__total" }
const _hoisted_25 = { class: "tariff-detail__total-values" }
const _hoisted_26 = {
  key: 0,
  class: "tariff-detail__original",
  "data-testid": "booking-detail-payment-total-original"
}
const _hoisted_27 = {
  class: "tariff-detail__final",
  "data-testid": "booking-detail-payment-total-final"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.footer.detailTitle")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseRows, (row) => {
          return (_openBlock(), _createBlock("div", {
            key: row.key,
            class: ["tariff-detail__row", { 'is-semibold': row.key === 'shipping-cost' }],
            "data-testid": `booking-v4-tarif-detail-${row.key}`
          }, [
            _createVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t(row.labelKey)) + " ", 1),
              (row.key === 'shipping-cost' && _ctx.woodpacking)
                ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("bookingV4.footer.woodpackingIncluded")), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("span", null, _toDisplayString(_ctx.currency(row.value)), 1)
          ], 10, ["data-testid"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.additionalRows, (row) => {
          return (_openBlock(), _createBlock("div", {
            key: row.key,
            class: ["tariff-detail__row", { 'is-semibold': row.key === 'total-additional-surcharge' }],
            "data-testid": `booking-v4-tarif-detail-${row.key}`
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.$t(row.labelKey)), 1),
            _createVNode("span", null, _toDisplayString(_ctx.currency(row.value)), 1)
          ], 10, ["data-testid"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.footer.protection")) + " ", 1),
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.protectionChecked
                  ? _ctx.$t("bookingV4.footer.protectionBasic")
                  : _ctx.$t("bookingV4.footer.protectionFree")), 1)
          ]),
          _createVNode("span", null, _toDisplayString(_ctx.currency(_ctx.estimationPrice.insuranceRates)), 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.footer.insuranceAdminFee")), 1),
          _createVNode("span", null, _toDisplayString(_ctx.currency(_ctx.estimationPrice.insuranceAdminFee)), 1)
        ])
      ]),
      (_ctx.isCodOrDfod)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.footer.codGoodsPrice")), 1),
              _createVNode("span", null, _toDisplayString(_ctx.currencyCod(_ctx.itemPrice || 0)), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("span", null, _toDisplayString(_ctx.codFeeLabel), 1),
              _createVNode("span", null, _toDisplayString(_ctx.currencyCod(_ctx.estimationPrice.codFee)), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.footer.codReturnFee")), 1),
              _createVNode("span", null, _toDisplayString(_ctx.currency(_ctx.codReturnFee)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasAnyDiscount)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.promoDiscounts, (promo, index) => {
              return (_openBlock(), _createBlock("div", {
                key: `${promo.pdcCategory}-${index}`,
                class: "tariff-detail__row black-text",
                "data-testid": "booking-detail-payment-promo-row black-text"
              }, [
                _createVNode("span", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_ctx.promoLabel(promo)) + " ", 1),
                  (promo.pdcPromoDiscount)
                    ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("bookingV4.footer.promoBadge", {
                  value: promo.pdcPromoDiscount
                })), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("span", _hoisted_19, "-" + _toDisplayString(_ctx.currency(promo.pdcDiscountAmount)), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFtz)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("bookingV4.footer.taxEstimation")), 1),
              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.currency(_ctx.estimationPrice.taxRates)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode("span", null, _toDisplayString(_ctx.totalLabel), 1),
      _createVNode("span", _hoisted_25, [
        (_ctx.showOriginalStrikethrough)
          ? (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.currency(_ctx.originalValue)), 1))
          : _createCommentVNode("", true),
        _createVNode("span", _hoisted_27, _toDisplayString(_ctx.isCodOrDfod ? _ctx.currencyCod(_ctx.finalValue) : _ctx.currency(_ctx.finalValue)), 1)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.isShow]
  ])
})